// app/lib/api/utils.ts
export const BASE_URL = 'https://api.saved.gg';

declare global {
  interface Window {
    Clerk: any;
  }
}

declare global {
  function gtag_report_conversion(url?: string): boolean;
}

export function log(message: string, data?: any) {
  console.log(`[API] ${message}`, data ? data : '');
}

export async function createHeaders() {
  const headers = new Headers();
  headers.append('Content-Type', 'application/json');
  headers.append('Accept', 'application/json');
  
  // Get the Clerk token
  const clerkToken = await window.Clerk.session?.getToken({
    template: "supabase",
  });
  headers.append('Authorization', `Bearer ${clerkToken}`);
  return headers;
}